<ng-container *ngIf="!isLoading; else loadingTopBar">
  <!-- Meta Bar -->
  <div class="meta-bar" *ngIf="metaMenu?.length">
    <div class="container h-100">
      <div class="meta-bar__row">
        <div class="meta-bar__row__section">
          <div
            class="meta-bar__row__section__item"
            *ngFor="let item of metaMenu"
          >
            <hdi-link
              [href]="item.url"
              [type]="LinkType.NOSTYLES"
              [label]="item.title"
              [hrefType]="
                item.url.startsWith('http') ||
                item.url.startsWith('www') ||
                item.url.startsWith('https')
                  ? HrefType.EXTERNAL
                  : HrefType.ANGULAR_ROUTE
              "
              [title]="item.hoverText || item.title"
              >{{ item.title }}</hdi-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Meta Bar -->
  <!-- Top Bar -->
  <div
    class="top-bar"
    [ngClass]="{
      'top-bar--front-mobile': isMenuOpen,
      'top-bar--front-desktop': isFlyoutOpen,
      'top-bar--slide-up': slideUp,
    }"
  >
    <ng-container>
      <div class="top-bar__row container">
        <div
          (click)="navigateToHomepage()"
          (keydown)="navigateToHomepage()"
          class="top-bar__row__section top-bar__row__section--logo"
        >
          <hdi-logo></hdi-logo>
          <p class="top-bar__row__section--logo__text">Bancassurance</p>
        </div>
        <!-- Menu Desktop -->
        <div class="top-bar__row__section top-bar__row__section--main-nav">
          <div
            class="top-bar__row__section--main-nav__item"
            [ngClass]="{
              'top-bar__row__section--main-nav__item--active':
                (!isFlyoutOpen && currentUrl.includes(item.url)) ||
                (isFlyoutOpen && flyoutOverview.url.includes(item.url)),
            }"
            *ngFor="let item of mainMenu"
          >
            <hdi-button
              [label]="item.title"
              (click)="openFlyout(item)"
              (keydown)="openFlyout(item)"
              [type]="ButtonType.CHILDREN"
              [bold]="false"
            ></hdi-button>
          </div>
        </div>
        <!-- End Menu Desktop -->
        <!-- Menu Mobile -->
        <div class="top-bar__row__section top-bar__row__section--mobile">
          <span class="top-bar__row__section--mobile__button">
            <div
              class="burger-menu"
              (click)="toggleMenu()"
              (keydown)="handleKeyDown($event)"
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
            <span>Menü</span>
          </span>
        </div>
        <!-- End Menu Mobile -->
      </div>
    </ng-container>

    <div *ngIf="isMenuOpen" class="top-bar__mobile-menu" #dropMenu>
      <ul>
        <hdi-dropdown-nav
          *ngFor="let menuItem of dropDownMenu"
          [menuItem]="menuItem"
          (closeMenu)="handleCloseMenu()"
        ></hdi-dropdown-nav>
      </ul>
    </div>
  </div>
  <!-- End Top Bar -->
  <hdi-flyout
    *ngIf="isFlyoutOpen"
    [isSimple]="flyoutOverview.isSimple"
    [title]="flyoutOverview.title"
    [pages]="currentFlyout"
    [overviewUrl]="flyoutOverview.url"
    (closeFlyout)="closeFlyout()"
  ></hdi-flyout>
</ng-container>

<!-- Loading Placeholder -->
<ng-template #loadingTopBar>
  <hdi-top-bar-loader></hdi-top-bar-loader>
</ng-template>
